<template>
  <body id="poster">
    <div
      style="   width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;"
    >
      <div class="login-box">
        <div class="titleBox">
          <div class="title">账号运营系统</div>
          <div class="titleOld">原媒体自动化系统</div>
        </div>
        <el-form
          class="login-container"
          label-position="left"
          label-width="0px"
        >
          <el-form-item>
            <el-input
              type="text"
              v-model="loginForm.username"
              auto-complete="off"
              placeholder="账号"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-input
              type="password"
              v-model="loginForm.password"
              auto-complete="off"
              placeholder="密码"
            ></el-input>
          </el-form-item>

          <el-form-item style="width: 100%">
            <el-button
              :loading="loading"
              type="primary"
              style="width: 100%;background: #06741a;border: none"
              v-on:click="doLogin"
            >
              登录
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </body>
</template>

<script>
import { login } from '../../api/user.js'

export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        username: process.env.VUE_APP_USER_NAME,
        password: process.env.VUE_APP_PASSWORD
      },
      responseResult: [],
      loading: false
    }
  },
  created() {
    window.localStorage.setItem('origin', '/login')
  },
  methods: {
    async doLogin() {
      try {
        // let that = this
        this.loading = true
        const userInfo = await login(this.loginForm)
        // const userInfo = await authLogin({ origin, auth })
        // await loginUserInfo().then(resp => {
        //   window.localStorage.setItem('roles', resp.roles)
        //   sessionStorage.setItem('userInfo', JSON.stringify(resp))
        //   that.$store.commit('user/SET_INFO')
        // })

        if (userInfo.is_staff) {
          window.localStorage.setItem('roles', 'ADMIN|USER')
        } else {
          window.localStorage.setItem('roles', 'USER')
        }
        localStorage.setItem('userInfo', JSON.stringify(userInfo))
        this.$store.commit('user/SET_INFO')
        window.localStorage.setItem('origin', '/login')
        // loadingInstance.close()
        this.$router.push('/')
        // await loginUserInfo().then(resp => {
        //   console.log(resp)
        //   //console.log(resp.roles)
        //   window.localStorage.setItem('roles', resp.roles)
        //   sessionStorage.setItem('userInfo', JSON.stringify(resp))
        //   that.$store.commit('user/SET_INFO')
        // })
        this.$router.push('/')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style>
#poster {
  background: url('../../assets/loginImages/bg.png') no-repeat;
  background-position: center;
  height: 100%;
  width: 100%;
  background-size: cover;
  position: fixed;
}

body {
  margin: 0px;
  padding: 0;
}

.login-container {
  border-radius: 15px;
  background-clip: padding-box;
  margin: 40px 0 10px;
  width: 80%;
  background: #fff;
 }

.login_title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}
.titleBox {
  text-align: center;
  background: #06741a;
  color: #fff;
  padding: 20px 0;
  width: 100%;
  border-radius: 5px 5px 0 0;
  .title {
    font-size: 26px;
  }
  .titleOld {
    color: #aab3ab;
  }
}
  .login-box {
    border-radius: 15px;
    background-clip: padding-box;
    width: 380px;
     background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

    .titleBox {
      text-align: center;
      background:#06741a;
      color: #fff;
      padding: 20px 0;
      width: 100%;
      border-radius: 5px 5px 0 0;
      .title {
        font-size: 26px;

      }
      .titleOld {
        color: #aab3ab;
      }
    }
    h3 {
      font-size: 22px;
    }

    .memo {
      color: #a2a1a1;
    }
  }

</style>
